import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import { Modal } from "@/Common/Components/Modals/Modal";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { Person } from "@/Common/Models/Person/Person";
import { DisplayPatientComparison } from "./DisplayPatientComparison";

interface IWarningPopupProps {
    onClose: () => void;
    errorMessageKey: string;
    patientA: Person;
    patientB: Person
}

function PatientMergeRequestWarningPopup({ onClose, errorMessageKey, patientA, patientB }: Readonly<IWarningPopupProps>): JSX.Element {
    const { getText } = useTranslation();

    return (
        <Modal
            title={getText("WarningLabel")}
            showX
            showOverlay
            onClose={onClose}
            footer={(
                <div className="flex-display flex-end">
                    <ButtonControl
                        variant="brand"
                        label={getText("OKLabel")}
                        onClick={onClose}
                    />
                </div>
            )}
        >
            <p>{getText(errorMessageKey)}</p>
            <DisplayPatientComparison patientA={patientA} patientB={patientB} />
        </Modal>
    );
}

export { PatientMergeRequestWarningPopup as WarningPopup };
